export const TITLE_SOURCES = {
  phone: "phone",
  provider: "provider"
};
